import React, {useState, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {Col, Row, Typography, Space, Select as AntSelect} from 'antd'
import {useInjection} from 'dna-react-ioc'
import {useScreenType} from '@/hooks'
import {Select, Button} from '@/components'
import {DefaultMerchantStoreInterface} from '@/pages/Profile/components'

import styles from './styles.scss'

const {Option} = AntSelect

export const DefaultMerchantStoreSymbol = Symbol('DefaultMerchantStore')

export const DefaultMerchant = observer(() => {
    const {t} = useTranslation()
    const {isMobile, isTablet} = useScreenType()
    const [localDefaultMerchant, setLocalDefaultMerchant] = useState<string>()

    const {isLoading, options, savedDefaultMerchant, setDefaultMerchant} =
        useInjection<DefaultMerchantStoreInterface>(DefaultMerchantStoreSymbol)

    useEffect(() => {
        setLocalDefaultMerchant(savedDefaultMerchant || undefined)
    }, [savedDefaultMerchant])

    const isButtonsVisible: boolean =
        Boolean(localDefaultMerchant) && localDefaultMerchant !== savedDefaultMerchant

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} md={24} lg={12}>
                <Typography.Title level={4}>{t('DefaultMerchant.title')}</Typography.Title>
                <Typography.Text>{t('DefaultMerchant.text')}</Typography.Text>
            </Col>

            <Col xs={24} md={24} lg={8} offset={isMobile || isTablet ? 0 : 4}>
                <Select
                    className={styles.select}
                    value={localDefaultMerchant}
                    options={options}
                    popupClassName={styles.dropdown}
                    onSelect={(v) => setLocalDefaultMerchant(v)}
                    placeholder={t('DefaultMerchant.selectPlaceholder')}
                >
                    {options?.map((option) => (
                        <Option key={option?.value} value={option?.value} label={option?.label}>
                            <div className={styles.option}>
                                <div title={option?.label} className={styles.optionLabel}>
                                    {option?.label}
                                </div>
                                <div title={option?.subLabel} className={styles.optionSubLabel}>
                                    {option?.subLabel}
                                </div>
                            </div>
                        </Option>
                    ))}
                </Select>

                {isButtonsVisible && (
                    <div className={styles.buttonsHolder}>
                        <Space>
                            <Button
                                onClick={() => setLocalDefaultMerchant(savedDefaultMerchant)}
                                disabled={isLoading}
                            >
                                {t('DefaultMerchant.cancel')}
                            </Button>

                            <Button
                                type={'primary'}
                                onClick={() =>
                                    setDefaultMerchant({
                                        merchantId: localDefaultMerchant,
                                        isDefault: true
                                    })
                                }
                                disabled={isLoading}
                            >
                                {t('DefaultMerchant.save')}
                            </Button>
                        </Space>
                    </div>
                )}
            </Col>
        </Row>
    )
})
